import { render, staticRenderFns } from "./SkillCreate.vue?vue&type=template&id=1d19c7c2&"
import script from "./SkillCreate.vue?vue&type=script&lang=js&"
export * from "./SkillCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports